import constants from './CommonConstants';

export const WIDGET_TYPES = {
  SYSTEM_WIDGET: 'System Widget',
  CUSTOM_ATTRIBUTE_WIDGET: 'Custom Attribute Widget',
};

export const STAT_BAR_SCOPES = {
  ENTITY_LIST: 'list',
  ENTITY_360: '360',
};

export const SYSTEM_STAT_BAR_WIDGETS = {
  HEALTH: 'Health',
  HEALTH_360: 'Health 360',
  RENEWALS: 'Renewals',
  RENEWAL_360: 'Renewal 360',
  CSM_PULSE: 'CSM Pulse',
  CSM_PULSE_360: 'CSM Pulse 360',
  LIFECYCLE_STAGES: 'Lifecycle Stages',
  LIFECYCLE_STAGE_360: 'Lifecycle Stage 360',
  PIPELINES_OVERVIEW: 'Pipelines Overview',
  ENTITY_PIPELINES: 'Pipelines',
  NUMBER_OF_ACCOUNTS: 'Number of Accounts',
  NUMBER_OF_CONTACTS: 'Number of Contacts',
  NUMBER_OF_ORGANIZATIONS: 'Number of Organizations',
  NUMBER_OF_LINKED_ACCOUNTS: 'Number of Linked Accounts',
  NUMBER_OF_LINKED_CONTACTS: 'Number of Linked Contacts',
  NUMBER_OF_LINKED_ORGANIZATIONS: 'Number of Linked Organizations',
  NPS: 'NPS',
  NPS_360: 'NPS 360',
  CSAT: 'CSAT',
  CSAT_360: 'CSAT 360',
};

export const SYSTEM_STAT_BAR_WIDGETS_DISPLAY = {
  [SYSTEM_STAT_BAR_WIDGETS.HEALTH]: 'Health',
  [SYSTEM_STAT_BAR_WIDGETS.HEALTH_360]: 'Health 360',
  [SYSTEM_STAT_BAR_WIDGETS.RENEWALS]: 'Renewals',
  [SYSTEM_STAT_BAR_WIDGETS.RENEWAL_360]: 'Renewal 360',
  [SYSTEM_STAT_BAR_WIDGETS.CSM_PULSE]: 'CSM Pulse',
  [SYSTEM_STAT_BAR_WIDGETS.CSM_PULSE_360]: 'CSM Pulse 360',
  [SYSTEM_STAT_BAR_WIDGETS.LIFECYCLE_STAGES]: 'Lifecycle Stages',
  [SYSTEM_STAT_BAR_WIDGETS.LIFECYCLE_STAGE_360]: 'Lifecycle Stage 360',
  [SYSTEM_STAT_BAR_WIDGETS.PIPELINES_OVERVIEW]: 'Pipelines Overview',
  [SYSTEM_STAT_BAR_WIDGETS.ENTITY_PIPELINES]: 'Pipelines',
  [SYSTEM_STAT_BAR_WIDGETS.NUMBER_OF_ACCOUNTS]: 'Number of Accounts',
  [SYSTEM_STAT_BAR_WIDGETS.NUMBER_OF_CONTACTS]: 'Number of Contacts',
  [SYSTEM_STAT_BAR_WIDGETS.NUMBER_OF_ORGANIZATIONS]: 'Number of Organizations',
  [SYSTEM_STAT_BAR_WIDGETS.NUMBER_OF_LINKED_ACCOUNTS]: 'Active Accounts',
  [SYSTEM_STAT_BAR_WIDGETS.NUMBER_OF_LINKED_CONTACTS]: 'Active Contacts',
  [SYSTEM_STAT_BAR_WIDGETS.NUMBER_OF_LINKED_ORGANIZATIONS]:
    'Active Organizations',
  [SYSTEM_STAT_BAR_WIDGETS.NPS]: 'NPS',
  [SYSTEM_STAT_BAR_WIDGETS.NPS_360]: 'NPS 360',
  [SYSTEM_STAT_BAR_WIDGETS.CSAT]: 'CSAT',
  [SYSTEM_STAT_BAR_WIDGETS.CSAT_360]: 'CSAT 360',
};

export const ENTITY_SYSTEM_WIDGET_OPTIONS = {
  [constants.ORGANIZATION_LEVEL]: [
    SYSTEM_STAT_BAR_WIDGETS.HEALTH,
    SYSTEM_STAT_BAR_WIDGETS.RENEWALS,
    SYSTEM_STAT_BAR_WIDGETS.CSM_PULSE,
    SYSTEM_STAT_BAR_WIDGETS.LIFECYCLE_STAGES,
  ],
  [constants.ACCOUNT_LEVEL]: [
    SYSTEM_STAT_BAR_WIDGETS.HEALTH,
    SYSTEM_STAT_BAR_WIDGETS.RENEWALS,
    SYSTEM_STAT_BAR_WIDGETS.CSM_PULSE,
    SYSTEM_STAT_BAR_WIDGETS.LIFECYCLE_STAGES,
  ],
  [constants.CONTACT_LEVEL]: [
    SYSTEM_STAT_BAR_WIDGETS.CSM_PULSE,
    SYSTEM_STAT_BAR_WIDGETS.LIFECYCLE_STAGES,
  ],
  [constants.PIPELINE_LEVEL]: [SYSTEM_STAT_BAR_WIDGETS.PIPELINES_OVERVIEW],
};

export const CSM_PULSE_VALUES = {
  HIGH_RISK: 1,
  SOME_RISK: 2,
  MODERATE: 3,
  SATISFIED: 4,
  VERY_SATISFIED: 5,
};

export const CSM_PULSE_VALUE_LABEL_MAP = {
  [CSM_PULSE_VALUES.HIGH_RISK]: 'High Risk',
  [CSM_PULSE_VALUES.SOME_RISK]: 'Some Risk',
  [CSM_PULSE_VALUES.MODERATE]: 'Moderate',
  [CSM_PULSE_VALUES.SATISFIED]: 'Satisfied',
  [CSM_PULSE_VALUES.VERY_SATISFIED]: 'Very Satisfied',
};

export const GLOBAL_CONFIG_TYPE_LABELS = {
  COUNT: 'Count',
  MRR: 'MRR',
  ARR: 'ARR',
};

export const GLOBAL_CONFIG_TYPE_FIELDS = {
  COUNT: 'count',
  MRR: 'mrr',
  ARR: 'arr',
};

export const CSAT_SCORE_VALUES = {
  VERY_DISSATISFIED: 1,
  DISSATISFIED: 2,
  NEUTRAL: 3,
  SATISFIED: 4,
  VERY_SATISFIED: 5,
};

export const CSAT_SCORE_VALUES_LABEL_MAP = {
  [CSAT_SCORE_VALUES.VERY_DISSATISFIED]: 'Very Dissatisfied',
  [CSAT_SCORE_VALUES.DISSATISFIED]: 'Dissatisfied',
  [CSAT_SCORE_VALUES.NEUTRAL]: 'Neutral',
  [CSAT_SCORE_VALUES.SATISFIED]: 'Satisfied',
  [CSAT_SCORE_VALUES.VERY_SATISFIED]: 'Very Satisfied',
};
